export default function () {
  var addRow = function() {
    var rows = $('.invoice-rows');
    var prototype = $('#prototype').html();
    var index = rows.data('index') ? rows.data('index') : rows.find('.invoice-row').length;
    var newForm = prototype.replace(/__name__/g, index);

    rows.append(newForm);
    rows.data('index', index + 1);
  };

  var reorderRows = function() {
    var rows = $('.invoice-rows');
    rows.find('.invoice-row').each(function(index) {
      $(this).find('.sort-order').val(index);
    });
  };

  $('.add-row').click(function(e) {
    e.preventDefault();
    addRow();
    reorderRows();
  });

  $(document).on('click', '.invoice-row .remove', function(e) {
    e.preventDefault();
    $(this).parent().parent().remove();
    reorderRows();
  });

  $(document).on('click', '.invoice-row .move-up', function(e) {
    e.preventDefault();
    var row = $(this).parent().parent();
    var target = row.prev();
    row.insertBefore(target);
    reorderRows();
  });

  $(document).on('click', '.invoice-row .move-down', function(e) {
    e.preventDefault();
    var row = $(this).parent().parent();
    var target = row.next();
    row.insertAfter(target);
    reorderRows();
  });

  reorderRows();
};



// WEBPACK FOOTER //
// ./assets/js/create-invoice.js